/**
 * Safe access to build-time env vars injected by host apps (DefinePlugin) or Jest.
 * ui-common is pre-bundled for the browser — never use bare `process.env` in src.
 */
type BuildEnv = {
  ALLOW_CONCURRENT_CASE_EDIT?: string;
  JEST_WORKER_ID?: string;
  REACT_APP_DICT_TENANT_OVERRIDE?: string;
};

const getBuildEnv = (): BuildEnv | undefined => {
  const g = globalThis as typeof globalThis & { process?: { env?: BuildEnv } };
  return g.process?.env;
};

/** Read a build env var when the host app or test runner has injected `process.env`. */
export const readBuildEnv = (key: keyof BuildEnv): string | undefined =>
  getBuildEnv()?.[key];

/** Suppress logger output under Jest (matches prior `process.env.JEST_WORKER_ID` check). */
export const isJestRuntime = (): boolean => Boolean(getBuildEnv()?.JEST_WORKER_ID);
